import { IAddToCartSellEvent } from "./addToCartSellPayload.dto";
import { INITIAL_SALE_EVENT_CONTEXT } from "../../../constants";
import { validateSessionByCookie } from "../../services/cookies";

export const handleAddToCartSellEvent = (data) => {
  const {
    env: environment,
    isApp: app,
    isCorpo: corp,
  } = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");
  const hm = getHm(data);
  const isRoundtrip = data.queryStore.flightType === "RT";

  const fullTrips = (queryStore) => {
    let fullTrip, fullTripDates, fullTripBundles;
    if (queryStore.flightType === "RT") {
      fullTrip = `${queryStore.origin}-${queryStore.destination},${queryStore.destination}-${queryStore.origin}`;
      fullTripDates = `${queryStore.departureDate},${queryStore.arrivalDate},${queryStore.arrivalDate}-${queryStore.departureDate}`;
      fullTripBundles = `${bundle.origin.bundle[1].priceByPassengerTypes[0].fare.amount}|${bundle.return.bundle[1].priceByPassengerTypes[0].fare.amount}`;
    } else {
      fullTrip = `${queryStore.origin}-${queryStore.destination}`;
      fullTripDates = `${queryStore.departureDate}`;
      fullTripBundles =
        bundle.origin.bundle[1].priceByPassengerTypes[0].fare.amount;
    }
    return { fullTrip, fullTripDates, fullTripBundles };
  };

  const { queryStore, bundle } = data;
  const { fullTrip, fullTripDates, fullTripBundles } = fullTrips(queryStore);
  const orderIatas = (segment) => {
    const order = [segment.origin, segment.destination];
    order.sort();
    return order.join("");
  };

  let returnItems = [];

  const originItems = bundle.origin.segments.map((segment, index) => {
    return {
      item_id: `${orderIatas(
        segment
      )}|${bundle.origin.bundle[1].fareBasis.substring(1)}`,
      item_name: "Ticket",
      index: index + 1,
      item_category: `Tickets/${index === 0 ? "ida" : "conexion"}`,
      item_list_name: `${orderIatas(segment)}|IS`,
      item_variant: `${bundle.origin.bundle[1].fareBasis}|${segment.flight.flightNumber}`,
      price: bundle.origin.bundle[1].priceByPassengerTypes[0].fare.amount,
      quantity:
        parseInt(queryStore.ADT) +
        parseInt(queryStore.CHD || "0") +
        parseInt(queryStore.INF || "0"),
      tag_price: segment.bookingClass,
      fare_basis: bundle.origin.bundle[1].fareBasis,
      cabin: segment.cabinClass.toLowerCase(),
      date: new Date(segment.departure).toISOString().split("T")[0],
    };
  });
  if (isRoundtrip) {
    returnItems = bundle.return.segments.map((segment, index) => {
      return {
        item_id: `${orderIatas(
          segment
        )}|${bundle.return.bundle[1].fareBasis.substring(1)}`,
        item_name: "Ticket",
        index: index + 1,
        item_category: `Tickets/${
          index + 1 === bundle.return.segments.length ? "vuelta" : "conexion"
        }`,
        item_list_name: `${orderIatas(segment)}|IS`,
        item_variant: `${bundle.return.bundle[1].fareBasis}|${segment.flight.flightNumber}`,
        price: bundle.return.bundle[1].priceByPassengerTypes[0].fare.amount,
        quantity:
          parseInt(queryStore.ADT) +
          parseInt(queryStore.CHD || "0") +
          parseInt(queryStore.INF || "0"),
        tag_price: segment.bookingClass,
        fare_basis: bundle.return.bundle[1].fareBasis,
        cabin: segment.cabinClass.toLowerCase(),
        date: new Date(segment.departure).toISOString().split("T")[0],
      };
    });
  }

  const eventData: IAddToCartSellEvent = {
    event: "add_to_cart",
    event_params: {
      page_path: `/${hm}/flujo-compra/busqueda-vuelos`,
      micrositio: "booking",
      page_type: "Búsqueda de Vuelos",
      homemarket: hm,
      negocio: "retail",
      buy_instance: "IS",
      environment,
      app,
      corp,
      login: validateSessionByCookie(),
      initial_date: queryStore.departureDate,
      end_date: queryStore.arrivalDate,
      from_iata: queryStore.origin,
      to_iata: queryStore.destination,
      trip_type: isRoundtrip ? "roundtrip" : "oneway",
      passengers_adult: parseInt(queryStore.ADT),
      passengers_child: queryStore.CHD ? parseInt(queryStore.CHD) : 0,
      passengers_infant: queryStore.INF ? parseInt(queryStore.INF) : 0,
      passengers_pet: queryStore.PET ? parseInt(queryStore.PET) : 0,
      pax:
        parseInt(queryStore.ADT) +
        parseInt(queryStore.CHD || "0") +
        parseInt(queryStore.INF || "0"),
      full_trip: fullTrip,
      exchange_rate: null,
      full_trip_dates: fullTripDates,
      full_trip_fare_basis: fullTripBundles,
      ecommerce: {
        items: [...originItems, ...returnItems],
      },
    },
  };

  return eventData;
};

const getHm = (data) => {
  const url = data.hm;
  const hm = url.split("/")[2];

  return hm;
};
